import * as T from "@shared/types";
import { SHOPIFY_TEST_VENDOR_KEY } from "@client-shared/lib/constants";

/**
 * Filters authentication fields based on vendor context.
 * Removes the access token field for the Shopify test vendor.
 */
export const filterFields = (
  fields: T.AuthenticationField[] | undefined,
  vendorKey: string
): T.AuthenticationField[] | undefined => {
  // Remove the access token field just for the Shopify test vendor
  if (vendorKey === SHOPIFY_TEST_VENDOR_KEY) {
    fields = fields?.filter((field) => field.name !== "accessToken");
  }
  return fields;
};
